import Header from "./Header";
import Footer from "./Footer";

import youthIMG from "../../youth.jpg"
import shirts from "../../shirts.webp"
import store from "../../Photos/IMG_3750.jpg"
import racks from "../../Photos/8630107504946539490.JPG"

const timeline = [
    {
        name: 'Foundation Founded',
        description:
            'Initially founded to assist youth and families upon entering foster care system by supplying them with equipment, hygiene items, and clothing.',
        date: 'Jul 2020',
        dateTime: '2020-07',
    },
    {
        name: 'First Golf Tournament Fundraiser',
        description:
            'Annual golf tournament held at Schuylkill Country Club in Orwigsburg, PA.',
        date: 'May 2021',
        dateTime: '2021-5',
    },
    {
        name: 'Expanded Services',
        description:
            'Services expanded to all high risk youth including foster youth, youth reunited with biological family after foster care, youth aging out of foster care, as well as biological families to keep the family together.',
        date: 'Jun 2021',
        dateTime: '2021-06',
    },
    {
        name: 'Golf Outing',
        description:
            'Purchased a 12,000 square foot building which allows for more inventory.',
        date: 'Oct 2021',
        dateTime: '2021-10',
    },
]

const jobOpenings = [
    {
        id: 1,
        role: 'Baby Products New',
        href: '#',
        description: 'Quos sunt ad dolore ullam qui. Enim et quisquam dicta molestias. Corrupti quo voluptatum eligendi autem labore.',
        list: ['Diapers/Wipes', 'Pacifiers', 'Bottles', 'Sippy Cups'], // Changed `list` to an array
        salary: 'Accepted',
        location: 'New Condition Only',
    },
    {
        id: 2,
        role: 'Baby Products Used or Gently Loved',
        href: '#',
        description: 'Et veniam et officia dolorum rerum. Et voluptas consequatur magni sapiente amet voluptates dolorum. Ut porro aut eveniet.',
        list: ['Diaper Bags', 'Jumpers', 'Bouncers', 'Swings', 'Seats', 'Playmats', `Pack 'n play`, 'Strollers', 'High Chairs'], // Changed `list` to an array
        salary: 'Accepted',
        location: 'Used and or Gently Loved Condition',
    },
    {
        id: 3,
        role: 'Misc. New',
        href: '#',
        description: 'Veniam ipsam nisi quas architecto eos non voluptatem in nemo. Est occaecati nihil omnis delectus illum est.',
        list: ['Under Garments', 'Socks', 'Hygiene Items', 'Pillows', 'Journals', 'Gift Cards', 'Toys'], // Changed `list` to an array
        salary: 'Accepted',
        location: 'New Condition Only',
    },
    {
        id: 4,
        role: 'Misc.',
        href: '#',
        description: 'Veniam ipsam nisi quas architecto eos non voluptatem in nemo. Est occaecati nihil omnis delectus illum est.',
        list: ['Clothing', 'Bedding', 'Towels', 'Kitchen Utensils', 'Small Appliances', 'Books', 'Bibles', 'Bags'], // Changed `list` to an array
        salary: 'Accepted',
        location: 'New Or Used Condition',
    },
]

const stats = [
    { id: 1, name: 'Tops', value: '5,175' },
    { id: 2, name: 'Bottoms', value: '5,175' },
    { id: 3, name: 'Shoes', value: '5,175' },
    { id: 4, name: 'Underwear', value: '7,245' },
    { id: 6, name: 'Socks', value: '7,245' },
    { id: 6, name: 'Jackets', value: '5,175' },
    { id: 7, name: 'Pjs', value: '2,070' },
    { id: 8, name: 'New Beds', value: '178' },

]

const statsYears = [
    { id: 1, name: 'Youth Helped 2022', value: '581' },
    { id: 2, name: 'Youth Helped 2023', value: '747' },
    { id: 3, name: 'Youth Helped 2024', value: '1034' },
]


const LandingPage = () => {

    return (
        <div className="bg-white h-screen">
            {/* Header */}
            <Header Landing={true}/>

            <main className="isolate mb-10">

                {/*New Main*/}
                <div className="relative isolate overflow-hidden pt-14 bg-black">
                    <img
                      alt=""
                      src={store}
                      className="absolute inset-0 -z-10 size-full object-cover opacity-40"
                    />

                    <div
                      aria-hidden="true"
                      className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
                    >
                      <div
                        style={{
                          clipPath:
                            'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                        className="relative left-[calc(50%-11rem)] aspect-1155/678 w-144.5 -translate-x-1/2 rotate-30 bg-linear-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%-30rem)] sm:w-288.75"
                      />
                    </div>
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                      <div className="mx-auto max-w-2xl py-32 sm:py-48 lg:py-56">
                        <div className="hidden sm:mb-4 sm:flex sm:justify-center">
                          <div className="relative rounded-full px-3 py-1 text-sm/6 text-gray-400 ring-1 ring-white/10 hover:ring-white/20">
                            Announcing our 2025 Golf Outing!{' '}
                            <a href="/galleryactivities" className="font-semibold text-blue-600">
                              <span aria-hidden="true" className="absolute inset-0" />
                              Learn more <span aria-hidden="true">&rarr;</span>
                            </a>
                          </div>
                        </div>
                        <div className="text-center">
                          <h1 className="text-5xl font-semibold tracking-tight text-balance text-white sm:text-7xl">
                              Every Child Needs to Know Their Worth
                          </h1>
                          <p className="mt-6 text-lg font-medium text-pretty text-white sm:text-xl/8">
                              At Bridge 127, Inc. in Pottsville, Pennsylvania, we help high risk youth by
                              providing them and their families with clothing, personal care items, and other
                              basic necessities.
                          </p>
                          <div className="mt-10 flex items-center justify-center gap-x-6">
                            <a
                              href="https://app.aplos.com/aws/give/Bridge127"
                              className="rounded-md bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
                            >
                              Donate
                            </a>
                            <a href="/about-us" className="text-sm/6 font-semibold text-white">
                              Learn about us <span aria-hidden="true">→</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      aria-hidden="true"
                      className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
                    >
                      <div
                        style={{
                          clipPath:
                            'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                        className="relative left-[calc(50%+3rem)] aspect-1155/678 w-144.5 -translate-x-1/2 bg-linear-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%+36rem)] sm:w-288.75"
                      />
                    </div>
                  </div>

                {/*Main Section*/}
                <div className="hidden relative isolate -z-10">
                    <svg
                        aria-hidden="true"
                        className="absolute inset-x-0 top-0 -z-10 h-[64rem] w-full stroke-gray-200 [mask-image:radial-gradient(32rem_32rem_at_center,white,transparent)]"
                    >
                        <defs>
                            <pattern
                                x="50%"
                                y={-1}
                                id="1f932ae7-37de-4c0a-a8b0-a6e3b4d44b84"
                                width={200}
                                height={200}
                                patternUnits="userSpaceOnUse"
                            >
                                <path d="M.5 200V.5H200" fill="none"/>
                            </pattern>
                        </defs>
                        <svg x="50%" y={-1} className="overflow-visible fill-gray-50">
                            <path
                                d="M-200 0h201v201h-201Z M600 0h201v201h-201Z M-400 600h201v201h-201Z M200 800h201v201h-201Z"
                                strokeWidth={0}
                            />
                        </svg>
                        <rect fill="url(#1f932ae7-37de-4c0a-a8b0-a6e3b4d44b84)" width="100%" height="100%"
                              strokeWidth={0}/>
                    </svg>
                    <div
                        aria-hidden="true"
                        className="absolute left-1/2 right-0 top-0 -z-10 -ml-24 transform-gpu overflow-hidden blur-3xl lg:ml-24 xl:ml-48"
                    >
                        <div
                            style={{
                                clipPath:
                                    'polygon(63.1% 29.5%, 100% 17.1%, 76.6% 3%, 48.4% 0%, 44.6% 4.7%, 54.5% 25.3%, 59.8% 49%, 55.2% 57.8%, 44.4% 57.2%, 27.8% 47.9%, 35.1% 81.5%, 0% 97.7%, 39.2% 100%, 35.2% 81.4%, 97.2% 52.8%, 63.1% 29.5%)',
                            }}
                            className="aspect-[801/1036] w-[50.0625rem] bg-gradient-to-tr from-skyBlue to-softGold opacity-30"
                        />
                    </div>
                    <div
                        aria-hidden="true"
                        className="absolute inset-y-0 right-1/2 -z-10 -mr-96 w-[200%] origin-top-right skew-x-[-30deg] bg-white animate-fadeIn shadow-xl shadow-skyBlue ring-1 ring-indigo-50 sm:-mr-80 lg:-mr-96"
                    />
                    <div className="overflow-hidden">
                        <div className="mx-auto max-w-7xl px-6 pb-32 pt-36 sm:pt-60 lg:px-8 lg:pt-32">
                            <div className="mx-auto max-w-2xl gap-x-14 lg:mx-0 lg:flex lg:max-w-none lg:items-center">
                                <div className="animate-slideInLeft relative w-full lg:max-w-xl lg:shrink-0 xl:max-w-2xl">
                                    <h1 className="text-pretty text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
                                        Every Child Needs to Know Their Worth
                                    </h1>
                                    <p className="mt-8 text-pretty text-lg font-medium text-gray-500 sm:max-w-md sm:text-xl/8 lg:max-w-none">
                                        At Bridge 127, Inc. in Pottsville, Pennsylvania, we help high risk youth by
                                        providing them and their families with clothing, personal care items, and other
                                        basic necessities.
                                    </p>
                                </div>
                                <div className="animate-slideInRight mt-14 flex justify-end gap-8 sm:-mt-44 sm:justify-start sm:pl-20 lg:mt-0 lg:pl-0">
                                    <div
                                        className="ml-auto w-44 flex-none space-y-8 pt-32 sm:ml-0 sm:pt-80 lg:order-last lg:pt-36 xl:order-none xl:pt-80">
                                        <div className="relative">
                                            <img
                                                alt=""
                                                src="https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&h=528&q=80"
                                                className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                                            />
                                            <div
                                                className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10"/>
                                        </div>
                                    </div>
                                    <div className="mr-auto w-44 flex-none space-y-8 sm:mr-0 sm:pt-52 lg:pt-36">
                                        <div className="relative">
                                            <img
                                                alt=""
                                                src="https://images.unsplash.com/photo-1485217988980-11786ced9454?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&h=528&q=80"
                                                className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                                            />
                                            <div
                                                className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10"/>
                                        </div>
                                        <div className="relative">
                                            <img
                                                alt=""
                                                src="https://images.unsplash.com/photo-1559136555-9303baea8ebd?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&crop=focalpoint&fp-x=.4&w=396&h=528&q=80"
                                                className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                                            />
                                            <div
                                                className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10"/>
                                        </div>
                                    </div>
                                    <div className="w-44 flex-none space-y-8 pt-32 sm:pt-0">
                                        <div className="relative">
                                            <img
                                                alt=""
                                                src="https://images.unsplash.com/photo-1670272504528-790c24957dda?ixlib=rb-4.0.3&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&crop=left&w=400&h=528&q=80"
                                                className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                                            />
                                            <div
                                                className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10"/>
                                        </div>
                                        <div className="relative">
                                            <img
                                                alt=""
                                                src="https://images.unsplash.com/photo-1670272505284-8faba1c31f7d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&h=528&q=80"
                                                className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                                            />
                                            <div
                                                className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Timeline section */}
                <div className="mx-auto bg-white -mt-8 max-w-7xl px-6 lg:px-8 pt-6 pb-6 rounded-lg drop-shadow shadow-skyBlue shadow-xl">
                    <div
                        className="mx-auto grid max-w-2xl grid-cols-1 gap-8 overflow-hidden lg:mx-0 lg:max-w-none lg:grid-cols-4">
                        {timeline.map((item) => (
                            <div key={item.name}>
                                <time dateTime={item.dateTime}
                                      className="flex items-center text-sm/6 font-semibold text-blue-400">
                                    <svg viewBox="0 0 4 4" aria-hidden="true" className="mr-4 size-1 flex-none">
                                        <circle r={2} cx={2} cy={2} fill="currentColor"/>
                                    </svg>
                                    {item.date}
                                    <div
                                        aria-hidden="true"
                                        className="absolute -ml-2 h-px w-screen -translate-x-full bg-gray-900/10 sm:-ml-4 lg:static lg:-mr-6 lg:ml-8 lg:w-auto lg:flex-auto lg:translate-x-0"
                                    />
                                </time>
                                <p className="mt-6 text-lg/8 font-semibold tracking-tight text-gray-900">{item.name}</p>
                                <p className="mt-1 text-base/7 text-gray-600">{item.description}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/*Stats Yearly*/}
                <div className="bg-white py-12 sm:py-12 mt-12">
                  <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <dl className="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-3">
                      {statsYears.map((stat) => (
                        <div key={stat.id} className="mx-auto flex max-w-xs flex-col gap-y-4">
                          <dt className="text-base/7 text-gray-600">{stat.name}</dt>
                          <dd className="order-first text-3xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                            {stat.value}
                          </dd>
                        </div>
                      ))}
                    </dl>
                  </div>
                </div>

                {/*Stat*/}
                <div className="relative max-w-7xl sm:mt-12 sm:px-6 lg:px-8 mx-auto rounded-2xl isolate overflow-hidden bg-gray-900 drop-shadow shadow-skyBlue shadow-xl py-12 sm:py-32">
                    <img
                        alt=""
                        src={youthIMG}
                        className="absolute inset-0 opacity-30 -z-10 size-full object-cover"
                    />
                    <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
                        <div
                            aria-hidden="true"
                            className="absolute -bottom-8 -left-96 -z-10 transform-gpu blur-3xl sm:-bottom-64 sm:-left-40 lg:-bottom-32 lg:left-8 xl:-left-10"
                        >
                            <div
                                style={{
                                    clipPath:
                                        'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                                }}
                                className="aspect-[1266/975] w-[79.125rem] bg-gradient-to-tr from-skyBlue to-blue-400 opacity-20"
                            />
                        </div>
                        <div className="mx-auto max-w-3xl lg:mx-0 lg:max-w-4xl">
                            <h2 className="text-base/8 font-semibold text-softGold">Our track record</h2>
                            <p className="mt-2 text-pretty text-3xl font-semibold tracking-tight text-white sm:text-3xl">
                                Making a Difference, One Donation at a Time
                            </p>
                            <p className="mt-6 text-lg/8 text-gray-300">
                                Thanks to the generosity of our supporters, we’ve proudly donated over <span className="text-softGold font-bold">50,000 essential items</span> to foster children and at-risk youth. From warm clothing to school supplies, every item helps brighten futures and transform lives.
                            </p>
                        </div>
                        <dl className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-10 text-white sm:mt-20 sm:grid-cols-2 sm:gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-8">
                            {stats.map((stat) => (
                                <div key={stat.id} className="flex flex-col gap-y-3 border-l border-white/10 pl-6">
                                    <dt className="text-sm/6">{stat.name}</dt>
                                    <dd className="order-first text-3xl font-semibold tracking-tight">{stat.value}</dd>
                                </div>
                            ))}
                        </dl>
                    </div>
                </div>

                {/* Our Dedication */}
                <div className="mt-32 overflow-hidden sm:mt-40">
                    <div className="mx-auto max-w-7xl px-6 lg:flex lg:px-8">
                        <div
                            className="mx-auto grid max-w-2xl grid-cols-1 gap-x-12 gap-y-16 lg:mx-0 lg:min-w-full lg:max-w-none lg:flex-none lg:gap-y-8">
                            <div className="lg:col-end-1 lg:w-full lg:max-w-lg lg:pb-8">
                                <h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">Our
                                    Dedication</h2>
                                <p className="mt-6 text-xl/8 text-gray-600">
                                    Dedicated to the Welfare of High Risk Youth
                                </p>
                                <p className="mt-6 text-base/7 text-gray-600">
                                    Children deserve to be raised in a healthy and nurturing environment while receiving
                                    all resources that are necessary for their holistic growth. At Bridge 127, Inc. in
                                    Pottsville, Pennsylvania, we help high risk youth by providing them and their
                                    families with clothing, personal care items, and other basic necessities.
                                </p>
                                <p className="mt-6 text-base/7 text-gray-600">
                                    We strive to enhance the quality of life for children, in their own home, in out-of-home care,
                                    those who are about to age out of the system, and those stuck somewhere in between. Continue
                                    exploring our website for more details about our nonprofit organization.
                                </p>
                            </div>
                            <div className="flex flex-wrap items-start justify-end gap-6 sm:gap-8 lg:contents">
                                <div className="w-0 flex-auto lg:ml-auto lg:w-auto lg:flex-none lg:self-end">
                                    <img
                                        alt=""
                                        src={racks}
                                        // src="https://images.unsplash.com/photo-1670272502246-768d249768ca?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1152&q=80"
                                        className="aspect-[7/5] w-[37rem] max-w-none rounded-2xl bg-gray-50 object-cover"
                                    />
                                </div>
                                <div
                                    className="contents lg:col-span-2 lg:col-end-2 lg:ml-auto lg:flex lg:w-[37rem] lg:items-start lg:justify-end lg:gap-x-8">
                                    <div className="order-first flex w-64 flex-none justify-end self-end lg:w-auto">
                                        <img
                                            alt=""
                                            src="https://images.unsplash.com/photo-1605656816944-971cd5c1407f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=768&h=604&q=80"
                                            className="aspect-[4/3] w-[24rem] max-w-none flex-none rounded-2xl bg-gray-50 object-cover"
                                        />
                                    </div>
                                    <div className="flex w-96 flex-auto justify-end lg:w-auto lg:flex-none">
                                        <img
                                            alt=""
                                            src="https://images.unsplash.com/photo-1568992687947-868a62a9f521?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1152&h=842&q=80"
                                            className="aspect-[7/5] w-[37rem] max-w-none flex-none rounded-2xl bg-gray-50 object-cover"
                                        />
                                    </div>
                                    <div className="hidden sm:block sm:w-0 sm:flex-auto lg:w-auto lg:flex-none">
                                        <img
                                            alt=""
                                            src="https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=768&h=604&q=80"
                                            className="aspect-[4/3] w-[24rem] max-w-none rounded-2xl bg-gray-50 object-cover"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/*Donation section */}
                <div className="mx-auto mt-32 max-w-7xl px-6 sm:mt-40 lg:px-8">
                    <div className="mx-auto flex max-w-2xl flex-col items-end justify-between gap-16 lg:mx-0 lg:max-w-none lg:flex-row">
                        <div className="w-full lg:max-w-lg lg:flex-auto">
                            <h2 className="text-pretty text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl">
                                We’re always looking for donations
                            </h2>
                            <p className="mt-6 text-xl/8 text-gray-600">
                                We are accepting the following donations (new or in good condition). If you dont see it below call and ask about specific items!:
                            </p>
                            <img
                                alt=""
                                src={shirts}
                                className="mt-16 aspect-[6/5] w-full rounded-2xl bg-gray-50 object-cover lg:aspect-auto lg:h-[34.5rem]"
                            />
                        </div>
                        <div className="w-full lg:max-w-xl lg:flex-auto">
                            <h3 className="sr-only">Job openings</h3>
                            <ul className="-my-8 divide-y divide-gray-100">
                                {jobOpenings.map((opening) => (
                                    <li key={opening.id} className="py-8">
                                        <dl className="relative flex flex-wrap gap-x-3">
                                            <dt className="sr-only">Role</dt>
                                            <dd className="w-full flex-none text-lg font-semibold tracking-tight text-gray-900">
                                                <a href={opening.href}>
                                                    {opening.role}
                                                    <span aria-hidden="true" className="absolute inset-0"/>
                                                </a>
                                            </dd>
                                            {/*<dt className="sr-only">Description</dt>*/}
                                            <ul className="mt-4 grid grid-cols-4 gap-4 pl-0">
                                                {opening.list.map((listItem, index) => (
                                                    <li key={index} className="list-none">
                                                        - {listItem}
                                                    </li>
                                                ))}
                                            </ul>
                                            <dd className="mt-2 w-full flex-none text-base/7 text-gray-600"></dd>
                                            <dt className="sr-only">Salary</dt>
                                            <dd className="mt-4 text-base/7 font-semibold text-gray-900">{opening.salary}</dd>
                                            <dt className="sr-only">Location</dt>
                                            <dd className="mt-4 flex items-center gap-x-3 text-base/7 text-gray-500">
                                                <svg viewBox="0 0 2 2" aria-hidden="true"
                                                     className="size-0.5 flex-none fill-gray-300">
                                                    <circle r={1} cx={1} cy={1}/>
                                                </svg>
                                                {opening.location}
                                            </dd>
                                        </dl>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

            </main>

            {/* Footer */}
            <Footer/>

        </div>
    )
};

export default LandingPage;
